// export const API_BASE_URL = process.env.REACT_APP_SERVER_URL;
export const ACCESS_TOKEN_NAME = "login_access_token";
export const API_BASE_URL = "https://build-communication.herokuapp.com";
// export const API_BASE_URL = "http://localhost:5000";
